import React, { useState } from 'react';
import { Phone, MessageSquare, X } from 'lucide-react';

export const CrisisFooter = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      {/* Persistent Footer Bar */}
      <div className="w-full" style={{ backgroundColor: '#F7F1EE', borderTop: '1px solid #EAE4DC' }}>
        <div className="max-w-4xl mx-auto px-4 py-2 flex items-center justify-center">
          <button
            onClick={() => setShowModal(true)}
            className="flex items-center gap-2 text-sm transition-colors hover:text-[#1A1A2E]"
            style={{ color: '#6B6878', fontFamily: 'Jost, sans-serif' }}
            data-testid="crisis-footer-button"
          >
            <Phone className="w-4 h-4" />
            <span>Need immediate support?</span>
          </button>
        </div>
      </div>

      {/* Crisis Modal */}
      {showModal && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center p-4"
          style={{ backgroundColor: 'rgba(26,26,46,0.35)', backdropFilter: 'blur(4px)' }}
          onClick={() => setShowModal(false)}
        >
          <div
            className="rounded-2xl max-w-md w-full p-6"
            style={{ backgroundColor: '#FFFFFF', border: '1px solid #EAE4DC', boxShadow: '0 12px 40px rgba(26,26,46,0.12)' }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex items-center justify-between mb-6">
              <h3 className="text-xl font-medium" style={{ fontFamily: 'Playfair Display, serif', color: '#1A1A2E' }}>
                Crisis Resources
              </h3>
              <button
                onClick={() => setShowModal(false)}
                className="p-1 rounded-full transition-colors hover:bg-[#F7F1EE]"
                style={{ color: '#8A8798' }}
                aria-label="Close crisis resources"
              >
                <X className="w-5 h-5" />
              </button>
            </div>

            <p className="text-sm mb-6" style={{ color: '#4A4A5A', fontFamily: 'Jost, sans-serif' }}>
              If you're in crisis or experiencing thoughts of self-harm, please reach out to one of these resources immediately.
            </p>

            <div className="space-y-4">
              <a
                href="tel:988"
                className="flex items-center gap-4 p-4 rounded-xl transition-colors hover:bg-[#F0EBE4]"
                style={{ backgroundColor: '#F7F1EE', border: '1px solid #F0EBE4' }}
                data-testid="crisis-988-link"
              >
                <div className="w-12 h-12 rounded-full flex items-center justify-center" style={{ backgroundColor: 'rgba(169,117,107,0.12)' }}>
                  <Phone className="w-6 h-6" style={{ color: '#A9756B' }} />
                </div>
                <div>
                  <p className="font-medium" style={{ color: '#1A1A2E' }}>988 Suicide & Crisis Lifeline</p>
                  <p className="text-sm" style={{ color: '#6B6878' }}>Call or text 988</p>
                </div>
              </a>

              <a
                href="sms:741741?body=HELLO"
                className="flex items-center gap-4 p-4 rounded-xl transition-colors hover:bg-[#F0EBE4]"
                style={{ backgroundColor: '#F7F1EE', border: '1px solid #F0EBE4' }}
                data-testid="crisis-text-link"
              >
                <div className="w-12 h-12 rounded-full flex items-center justify-center" style={{ backgroundColor: 'rgba(114,130,111,0.12)' }}>
                  <MessageSquare className="w-6 h-6" style={{ color: '#72826F' }} />
                </div>
                <div>
                  <p className="font-medium" style={{ color: '#1A1A2E' }}>Crisis Text Line</p>
                  <p className="text-sm" style={{ color: '#6B6878' }}>Text HOME to 741741</p>
                </div>
              </a>

              <a
                href="tel:911"
                className="flex items-center gap-4 p-4 rounded-xl transition-colors hover:bg-[#F0EBE4]"
                style={{ backgroundColor: '#F7F1EE', border: '1px solid #F0EBE4' }}
                data-testid="crisis-911-link"
              >
                <div className="w-12 h-12 rounded-full flex items-center justify-center" style={{ backgroundColor: 'rgba(201,168,76,0.15)' }}>
                  <Phone className="w-6 h-6" style={{ color: '#C9A84C' }} />
                </div>
                <div>
                  <p className="font-medium" style={{ color: '#1A1A2E' }}>Emergency Services</p>
                  <p className="text-sm" style={{ color: '#6B6878' }}>Call 911</p>
                </div>
              </a>
            </div>

            <p className="text-xs mt-6 text-center" style={{ color: '#8A8798' }}>
              You are not alone. Help is available 24/7.
            </p>
          </div>
        </div>
      )}
    </>
  );
};
